import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { addNavMenuSection, registerDashboardWidget, setDashboardWidgetLayout } from '@vendure/admin-ui/core';
import { VisitorsWidgetComponent } from './visitors-widget.component';

@NgModule({
    imports: [
        CommonModule,
        VisitorsWidgetComponent,
    ],
    providers: [
        // === MENÚ: Sección "ESENCIA MODERNA" arriba de Catálogo ===
        addNavMenuSection({
            id: 'esencia-moderna',
            label: 'Esencia Moderna',
            items: [
                {
                    id: 'inicio',
                    label: 'Ir a la Tienda',
                    routerLink: ['/extensions', 'visitas', 'inicio-redirect'],
                    icon: 'home',
                },
                {
                    id: 'visitas-web',
                    label: 'Visitas Web',
                    routerLink: ['/extensions', 'visitas'],
                    icon: 'timeline',
                }
            ],
        }, 'catalog'), // Se ubica ANTES de la sección "catalog"

        // === DASHBOARD: Widget de visitantes en tiempo real ===
        registerDashboardWidget('em-visitors', {
            title: 'Visitas en Tiempo Real',
            supportedWidths: [6, 8, 12],
            loadComponent: () => VisitorsWidgetComponent,
        }),

        // === LAYOUT: Configurar el dashboard con el widget arriba ===
        setDashboardWidgetLayout([
            { id: 'em-visitors', width: 12 },
            { id: 'orderSummary', width: 6 },
            { id: 'latestOrders', width: 12 },
        ]),
    ],
})
export class UiSharedModule {}
